(() => {
  const modal = document.getElementById('AgeVerificationModal');
  if (!modal) return;

  const verifyButton = modal.querySelector('[data-age-verify]');
  const rejectButton = modal.querySelector('[data-age-reject]');
  const redirectUrl = modal.dataset.rejectUrl;

  document.body.classList.add('modal-open');

  const closeModal = () => {
    modal.hidden = true;
    document.body.classList.remove('modal-open');
  };

  const redirectVisitor = () => {
    if (redirectUrl) window.location.href = redirectUrl;
  };

  if (verifyButton) verifyButton.addEventListener('click', closeModal);
  if (rejectButton) rejectButton.addEventListener('click', redirectVisitor);
})();
